import { Component } from '@angular/core';
import { AlertController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { TPVServices } from '../../../tpv/services';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'create-table',
  templateUrl: 'create-table.html',
})
export class CompCreateTablePage {
  table: any;
  room: any;
  table_cash: string = '';
  update_state: boolean = false;

  constructor(
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController
  ) {
    this.table = this.navParams.get('table');
    this.room = this.navParams.get('room');
    this.update_state = this.navParams.get('update');
    if (this.update_state) {
      this.table_cash = `${this.table.cash_static} | ${this.table.cash_uid}`;
    }

    // Si es una nueva mesa, asignar una posición no solapada
    if (!this.update_state) {
      this.table.map_left = 0;
      this.table.map_top = 0;
      this.table.map_insert = true;
      this.table.position = this.findAvailablePosition();
    }
  }

  // Verifica si una posición está ocupada
  isPositionOccupied(x: number, y: number, width: number, height: number): boolean {
    return this.room.content.some(existingTable => {
      const existingX = existingTable.map_left || 0;
      const existingY = existingTable.map_top || 0;
      const existingWidth = this.getTableWidth(existingTable);
      const existingHeight = this.getTableHeight(existingTable);

      // Verificar solapamiento
      return (
        x < existingX + existingWidth &&
        x + width > existingX &&
        y < existingY + existingHeight &&
        y + height > existingY
      );
    });
  }

  // Encuentra la próxima posición disponible
  findAvailablePosition(): { x: number; y: number } {
    const margin = 10; // Margen entre mesas
    let x = 0;
    let y = 0;

    // Tamaño de la nueva mesa (ajusta según el tipo de mesa)
    const tableWidth = this.getTableWidth(this.table);
    const tableHeight = this.getTableHeight(this.table);

    // Buscar una posición no ocupada
    while (this.isPositionOccupied(x, y, tableWidth, tableHeight)) {
      x += tableWidth + margin; // Mover a la derecha
      if (x > 1000) { // Límite horizontal (ajusta según el tamaño del mapa)
        x = 0;
        y += tableHeight + margin; // Mover hacia abajo
      }
    }

    return { x, y };
  }

  // Obtener el ancho de la mesa según su tipo
  getTableWidth(table: any): number {
    switch (table.map_style) {
      case 'dnd-square':
        return 100;
      case 'dnd-circle':
        return 100;
      case 'dnd-circle-big':
        return 200;
      case 'dnd-rectangle':
        return 200;
      case 'dnd-rectangle-big':
        return 300;
      case 'dnd-rectangle-v':
        return 100;
      case 'dnd-rectangle-v-big':
        return 100;
      default:
        return 100;
    }
  }

  // Obtener la altura de la mesa según su tipo
  getTableHeight(table: any): number {
    switch (table.map_style) {
      case 'dnd-square':
        return 100;
      case 'dnd-circle':
        return 100;
      case 'dnd-circle-big':
        return 200;
      case 'dnd-rectangle':
        return 100;
      case 'dnd-rectangle-big':
        return 100;
      case 'dnd-rectangle-v':
        return 200;
      case 'dnd-rectangle-v-big':
        return 300;
      default:
        return 100;
    }
  }

  close(info_return = undefined) {
    this.viewCtrl.dismiss(info_return);
  }

  save() {
    if (this.checkInputs()) {
      var cash_split = this.table_cash.split('|');
      var cash_name = cash_split[0];
      var cash_uid = cash_split[1];
      this.table.cash_static = cash_name;
      this.table.cash_uid = cash_uid;

      // Asignar la posición calculada a la mesa
      if (!this.update_state) {
        this.table.map_left = this.table.position.x;
        this.table.map_top = this.table.position.y;
      }

      if (this.update_state) {
        this.updateTable(this.table);
      } else {
        this.insertTable(this.table);
      }
      this.close(this.table);
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-rellena-todos-campos-formulario'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  checkInputs() {
    if (!this.table_cash || !this.table.name) {
      return false;
    }
    return true;
  }

  insertTable(table_info) {
    this.tpvServices.afs.collection('tables').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'cash_static': table_info.cash_static.trim(),
      'cash_uid': table_info.cash_uid.trim(),
      'customer': {},
      'discount_type': '',
      'discount_value': 0,
      'name': table_info.name,
      'persons': table_info.persons || 0,
      'size': table_info.size || 2,
      'state': 'open',
      'ticket': {
        'amount': 0,
        'date': '',
        list: {},
        'number': '',
        'payment': false,
        'payment_type': '',
        'waiter': '',
        'waiter_uid': '',
        'updated_at': new Date(),
        'tip': 0
      },
      'type': 'table',
      'uid_room': this.room.UID,
      'map_style': table_info.map_style || 'dnd-square',
      'map_top': table_info.map_top,
      'map_left': table_info.map_left,
      'map_insert': table_info.map_insert,
      'room': this.room.name,
      'order': table_info.order || 0,
      'notes': '',
      'created_at': new Date()
    }).then(doc => {
      this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Table - Create', this.globals.restaurant.email, 'Create/Update', 'Create table room', 'Configuration', table_info.name);
    });
  }

  updateTable(table_info) {
    this.tpvServices.afs.collection('tables').doc(this.table.UID).update({
      'cash_static': table_info.cash_static.trim(),
      'cash_uid': table_info.cash_uid.trim(),
      'name': table_info.name,
      'persons': table_info.persons || 0,
      'size': table_info.size || 2,
      'order': table_info.order || 0,
      'map_style': table_info.map_style || 'dnd-square',
    }).then(() => {
      this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Table - Update', this.globals.restaurant.email, 'Create/Update', 'Update table room', 'Configuration', table_info.name);
    });
  }

  deleteTable() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-mesa'),
      message: this.translate.instant('instant-seguro-quieres-eliminarla'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Table - Delete', this.globals.restaurant.email, 'Delete', 'Delete table room', 'Configuration', this.table.name);
            this.tpvServices.afs.doc('tables/' + this.table.UID).delete();
            this.close();
          }
        }
      ]
    });
    alert.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/components/popups/create-table/create-table.ts